/* eslint-disable @typescript-eslint/no-explicit-any */
import { romPart } from 'consts/personnelData';
import {
  xlsxStats,
  xlsxHealthStats,
  genders,
  careers,
  ages
} from 'consts/commonData';

export const toTalper = (number: string, total: number) => {
  const percent = `${((Number(number) / total) * 100).toFixed(1)}`;
  return isNaN(Number(percent)) ? '0' : percent;
};

const useRomXlsxData = (data: any, productNumber: number) => {
  const selectedStats =
    productNumber === 4 || productNumber === 5 ? xlsxStats : xlsxHealthStats;

  const newXlsxDatas: any[] = [];

  for (const partData of romPart) {
    const colData: any[] = Array(6).fill('');
    colData[0] = partData.value;

    //부위
    for (const indicator of partData.indicators) {
      colData[1] = indicator.value;
      const indicatorData = data[indicator.key];
      if ('severity' in indicator) {
        const indicatorsWithSeverity = indicator as {
          severity: { key: string; value: string }[];
        };
        //지표
        for (const severity of indicatorsWithSeverity.severity) {
          const newDataPoint = [...colData];
          const severityData = indicatorData[severity.key];
          const severityPer = toTalper(severityData.total, indicatorData.total);
          newDataPoint[2] = `${severity.value}\n${severityPer}%\n${severityData.total}명`;

          //구분
          for (const stat of selectedStats) {
            const statsData = severityData[stat.key];
            newDataPoint[3] = stat.value;
            //상세구분
            if (stat.key === 'career') {
              for (const career of careers) {
                newDataPoint[4] = career.value;
                const careerData = statsData[career.key];
                newDataPoint[5] = toTalper(careerData, severityData.total);
                newDataPoint[6] = `${Number(careerData).toLocaleString()}`;
                newXlsxDatas.push([...newDataPoint]);
              }
            } else if (stat.key === 'age') {
              for (const age of ages) {
                newDataPoint[4] = age.value;
                const careerData = statsData[age.key];
                newDataPoint[5] = toTalper(careerData, severityData.total);
                newDataPoint[6] = `${Number(careerData).toLocaleString()}`;
                newXlsxDatas.push([...newDataPoint]);
              }
            } else if (stat.key === 'gender') {
              for (const gender of genders) {
                newDataPoint[4] = gender.value;
                const careerData = statsData[gender.key];
                newDataPoint[5] = toTalper(careerData, severityData.total);
                newDataPoint[6] = `${Number(careerData).toLocaleString()}`;
                newXlsxDatas.push([...newDataPoint]);
              }
            }
          }
        }
      } else {
        const newDataPoint = [...colData];
        const indicatorData = data[partData.key];
        const severityData = indicatorData[indicator.key];
        const severityPer = toTalper(severityData.total, indicatorData.total);
        newDataPoint[2] = `${indicator.value}\n${severityPer}%\n${indicatorData.total}명`;
        for (const stat of selectedStats) {
          const statsData = severityData;
          newDataPoint[3] = stat.value;

          if (stat.key === 'career') {
            for (const career of careers) {
              newDataPoint[4] = career.value;
              const careerData = statsData[stat.key][career.key];
              newDataPoint[5] = toTalper(careerData, statsData.total);
              newDataPoint[6] = `${Number(careerData).toLocaleString()}`;
              newXlsxDatas.push([...newDataPoint]);
            }
          } else if (stat.key === 'age') {
            for (const age of ages) {
              newDataPoint[4] = age.value;
              const careerData = statsData[stat.key][age.key];
              newDataPoint[5] = toTalper(careerData, statsData.total);
              newDataPoint[6] = `${Number(careerData).toLocaleString()}`;
              newXlsxDatas.push([...newDataPoint]);
            }
          } else if (stat.key === 'gender') {
            for (const gender of genders) {
              newDataPoint[4] = gender.value;
              const careerData = statsData[stat.key][gender.key];
              newDataPoint[5] = toTalper(careerData, statsData.total);
              newDataPoint[6] = `${Number(careerData).toLocaleString()}`;
              newXlsxDatas.push([...newDataPoint]);
            }
          }
        }
      }
    }
  }

  return newXlsxDatas;
};

export default useRomXlsxData;
